export const INITIAL_COMDOMINIUM_BLOCK_INFO_STATE = {
  condominiumLabel: '',
  condominiumFullCode: '',
  blockLabel: null,
  blockFullCode: null,
  condominiumId: null,
}
